export const TABLE_HEADER_CELL_CONSTS = {
  changeSortOrder: 'Изменить порядок сортировки',
  deleteColumnMsg: 'Удалить столбец',
  sortByFieldMsg: 'Сортировать по полю'
}
